import { Box, Typography } from '@mui/material';
import { Column, useFilters, useSortBy, useTable } from 'react-table';
import { MarginTarget } from 'shared/types';
import { DateColumn } from './columns/date-column';
import { EditableColumn } from './columns/editable-column';
import { ParameterTable } from './parameter-table';

interface MarginTargetsSectionProps {
    data: MarginTarget[];
}

export function MarginTargetsSection({ data }: MarginTargetsSectionProps) {
    const instance = useMarginTargetTableInstance(data);

    return (
        <Box width={{ xs: '100%', md: '80%', lg: '60%' }}>
            <ParameterTable title='Margin Targets' instance={instance} />
        </Box>
    );
}

const getRowId = (row: MarginTarget) => row.uniqueId;

export const defaultColumn: Partial<Column<MarginTarget>> = {
    Filter: () => null,
    Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
    disableFilters: true,
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    align: 'inherit',
    percent: true,
};

const marginTargetColumns: Column<MarginTarget>[] = [
    {
        Header: 'Level',
        accessor: 'level',
        align: 'left',
    },
    {
        Header: 'Value',
        accessor: 'value',
        align: 'left',
    },
    {
        Header: 'Tier',
        accessor: 'tier',
        align: 'left',
    },
    {
        Header: 'Margin Target',
        accessor: 'marginTarget',
        align: 'left',
        Cell: EditableColumn,
        section: 'marginTargets',
        rules: { min: { message: 'Margin target cannot be less than 0', value: 0 } },
        title: 'ideal margin % for products of a particular category and tier',
    },
    {
        Header: 'Last Updated',
        accessor: 'lastUpdated',
        align: 'left',
        Cell: DateColumn,
    },
];

export function useMarginTargetTableInstance(data: MarginTarget[]) {
    return useTable<MarginTarget>(
        {
            columns: marginTargetColumns,
            data,
            defaultColumn,
            getRowId,
            autoResetFilters: false,
            autoResetSortBy: false,
        },
        useFilters,
        useSortBy
    );
}
